import { lazy } from 'react';

const RecargosMora = lazy(() =>
  import('components/Configuraciones/RecargosMora/RecargosMora').then(module => ({
    default: module.RecargosMora,
  }))
);

const ConfiguracionMora = lazy(() =>
  import('components/Configuraciones/Configuracion-Mora/ConfiguracionMora').then(module => ({
    default: module.ConfiguracionMora,
  }))
);

const InterestSettings = lazy(() =>
  import('components/Configuraciones/Configuracion-Interes-Creditos/InterestSettings').then(module => ({
    default: module.InterestSettings,
  }))
);

const Houses = lazy(() =>
  import('components/Configuraciones/Houses/index').then(module => ({
    default: module.Houses,
  }))
);

const OrigenesCredito = lazy(() =>
  import('components/Configuraciones/OrigenesCredito/index').then(module => ({
    default: module.OrigenesCredito,
  }))
);

const ParametrosSistema = lazy(() =>
  import('components/Configuraciones/ParametrosSistema/index').then(module => ({
    default: module.ParametrosSistema,
  }))
);

const routesConfiguraciones = [
  {
    path: '/configuraciones-casas',
    name: 'Casas',
    icon: 'nc-icon nc-bank',
    component: <Houses />,
    permissions: ['210_CASAS'],
    layout: '/app',
    visibility: true,
    subRoutes: []
  },
  {
    path: '/origenes-de-credito',
    name: 'Origenes de Credito',
    icon: 'nc-icon nc-bank',
    component: <OrigenesCredito />,
    permissions: ['252_ORIGENES_DE_CREDITO'],
    layout: '/app',
    visibility: true,
    subRoutes: []
  },
  {
    path: '/parametros-de-sistema',
    name: 'Parámetros de Sistema',
    icon: 'nc-icon nc-bank',
    component: <ParametrosSistema />,
    permissions: ['254_PARAMETROS'],
    layout: '/app',
    visibility: true,
    subRoutes: []
  },
  // {
  //     path: '/configuraciones-recargos-mora',
  //     name: 'Recargos Mora',
  //     icon: 'nc-icon nc-bank',
  //     component: <RecargosMora />,
  //     permissions: ['153_RECARGOS_DE_MORA'],
  //     layout: '/app',
  //     visibility: true,
  //     subRoutes: []
  // },
  // {
  //     path: '/configuraciones-interes-moras',
  //     name: 'Interés Moras',
  //     icon: 'nc-icon nc-bank',
  //     component: <ConfiguracionMora />,
  //     permissions: ['154_INERES_DE_MORA'],
  //     layout: '/app',
  //     visibility: true,
  //     subRoutes: []
  // },
  // {
  //     path: '/configuraciones-interes-creditos',
  //     name: 'Interés Creditos',
  //     icon: 'nc-icon nc-bank',
  //     component: <InterestSettings />,
  //     permissions: ['155_INTERES_DE_CRÉDITOS'],
  //     layout: '/app',
  //     visibility: true,
  //     subRoutes: []
  // },
]

export { routesConfiguraciones }
